'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by zfc on 2016/10/24.
                                   */

// import GoeasyRadio from '../GoeasyInputField/GoeasyRadio';

// import RadioGroup from 'react-radio';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _reduxForm = require('redux-form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceOrderConfirmComponent = (_dec = (0, _reduxForm.reduxForm)({
  form: 'serviceOrderConfirmForm',
  fields: ['isExpress', 'consignee', 'consigneePhone', 'address', 'isInvoice', 'invoiceText', 'projectType']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ServiceOrderConfirmComponent, _Component);

  // fieldChange: PropTypes.func,
  // submit: PropTypes.func

  function ServiceOrderConfirmComponent() {
    (0, _classCallCheck3.default)(this, ServiceOrderConfirmComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ServiceOrderConfirmComponent).call(this));

    _this.state = {};
    return _this;
  }

  /*
   onFieldChange(val, field) {
   const {fieldChange} = this.props;
   if (fieldChange) {
   fieldChange(val, field);
   }
   }
   */

  (0, _createClass3.default)(ServiceOrderConfirmComponent, [{
    key: 'onIsExpressChange',
    value: function onIsExpressChange() {
      var isExpress = this.props.fields.isExpress;

      if (isExpress.value === '' || isExpress.value === '0') {
        isExpress.onChange('1');
      } else if (isExpress.value === '1') {
        isExpress.onChange('0');
      }
    }
  }, {
    key: 'onIsInvoiceChange',
    value: function onIsInvoiceChange() {
      var isInvoice = this.props.fields.isInvoice;

      if (isInvoice.value === '' || isInvoice.value === '0') {
        isInvoice.onChange('1');
      } else if (isInvoice.value === '1') {
        isInvoice.onChange('0');
      }
    }
  }, {
    key: 'onProjectTypeChange',
    value: function onProjectTypeChange(value) {
      var projectType = this.props.fields.projectType;

      projectType.onChange(value);
    }
  }, {
    key: 'invoiceTextInit',
    value: function invoiceTextInit(value) {
      var invoiceText = this.props.fields.invoiceText;

      invoiceText.onChange(value);
    }
  }, {
    key: 'consigneeInit',
    value: function consigneeInit(value) {
      var consignee = this.props.fields.consignee;

      consignee.onChange(value);
    }
  }, {
    key: 'consigneePhoneInit',
    value: function consigneePhoneInit(value) {
      var consigneePhone = this.props.fields.consigneePhone;

      consigneePhone.onChange(value);
    }
  }, {
    key: 'addressInit',
    value: function addressInit(value) {
      var address = this.props.fields.address;

      address.onChange(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var _props$fields = _props.fields;
      var isExpress = _props$fields.isExpress;
      var consignee = _props$fields.consignee;
      var consigneePhone = _props$fields.consigneePhone;
      var address = _props$fields.address;
      var isInvoice = _props$fields.isInvoice;
      var invoiceText = _props$fields.invoiceText;
      var projectType = _props$fields.projectType;
      var serviceOrderConfirmData = _props.serviceOrderConfirmData;
      var handleSubmit = _props.handleSubmit;

      var styles = require('./ServiceOrderConfirmComponent.scss');
      var expressDiv = '';
      var invoiceDiv = '';
      var payoracceptDiv = '';
      if (isExpress.value === '1') {
        expressDiv = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_GoeasyInputField2.default, { goeasyStyle: { width: '90%' }, afterInit: this.consigneeInit.bind(this), label: '收货人：',
            inputType: 'text',
            formProps: consignee }),
          _react2.default.createElement(_GoeasyInputField2.default, { goeasyStyle: { width: '90%' }, afterInit: this.consigneePhoneInit.bind(this), label: '联系方式：',
            inputType: 'text',
            formProps: consigneePhone }),
          _react2.default.createElement(_GoeasyInputField2.default, { goeasyStyle: { width: '90%' }, afterInit: this.addressInit.bind(this), label: '配送地址：',
            inputType: 'text',
            formProps: address })
        );
      }
      if (isInvoice.value === '1') {
        invoiceDiv = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_GoeasyInputField2.default, { goeasyStyle: { width: '90%' }, afterInit: this.invoiceTextInit.bind(this), label: '发票名头：',
            inputType: 'text',
            formProps: invoiceText }),
          _react2.default.createElement(
            'div',
            { className: styles.project },
            _react2.default.createElement(
              'h4',
              null,
              '开票项目：'
            ),
            _react2.default.createElement(
              'div',
              { style: { width: '77%', float: 'right' } },
              _react2.default.createElement(
                'select',
                { className: styles.selt,
                  value: projectType.value,
                  onChange: function onChange(event) {
                    return _this2.onProjectTypeChange(event.target.value);
                  } },
                serviceOrderConfirmData.projectTypeList.map(function (project, index) {
                  return _react2.default.createElement(
                    'option',
                    { key: index, Id: 'invoice_' + project.value,
                      value: project.value },
                    project.label
                  );
                })
              )
            )
          ),
          _react2.default.createElement('div', { className: 'clear' })
        );
      }
      /*
       switch (serviceOrderConfirmData.orderStatus) {
       case '待审核':
       payoracceptDiv = <div className={styles.din}>生成订单</div>;
       break;
       case '待确认':
       payoracceptDiv = <div className={styles.din}>生成订单</div>;
       break;
       case '待支付':
       payoracceptDiv = <div className={styles.din}>支付</div>;
       break;
       default:
       console.log(serviceOrderConfirmData.orderStatus);
       } */
      if (serviceOrderConfirmData.orderStatus === '待审核' || serviceOrderConfirmData.orderStatus === '待确认') {
        payoracceptDiv = _react2.default.createElement(
          'div',
          { className: styles.din },
          '提交订单'
        );
      } else if (serviceOrderConfirmData.orderStatus === '待支付') {
        payoracceptDiv = _react2.default.createElement(
          'div',
          { className: styles.din },
          '支付'
        );
      }
      return _react2.default.createElement(
        'div',
        { className: styles.serviceConfirmComponent },
        _react2.default.createElement(
          'div',
          { className: styles.xiodin },
          _react2.default.createElement(
            'span',
            null,
            '订单编号：'
          ),
          _react2.default.createElement(
            'span',
            { style: { width: 230 } },
            serviceOrderConfirmData.id
          ),
          _react2.default.createElement(
            'div',
            { className: styles.orderStatus },
            '状态:',
            serviceOrderConfirmData.orderStatus
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 8, float: 'right', border: 'none' },
              className: styles.xiodin },
            serviceOrderConfirmData.ordetTime
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { className: styles.newPage },
            _react2.default.createElement(
              'div',
              { className: styles.pageTopTitle },
              _react2.default.createElement(
                'span',
                null,
                '购买服务'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.box },
              _react2.default.createElement('img', (0, _defineProperty3.default)({ src: '', className: styles.boxImg }, 'src', serviceOrderConfirmData.img)),
              _react2.default.createElement(
                'div',
                { className: styles.serviceContent },
                _react2.default.createElement(
                  'div',
                  { className: styles.tit },
                  serviceOrderConfirmData.name
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  _react2.default.createElement(
                    'div',
                    { className: styles.textTil },
                    '服务商: '
                  ),
                  serviceOrderConfirmData.shop
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  _react2.default.createElement(
                    'div',
                    { className: styles.textTil },
                    '联系人: '
                  ),
                  serviceOrderConfirmData.contactPerson
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  _react2.default.createElement(
                    'div',
                    { className: styles.textTil },
                    '联系方式: '
                  ),
                  serviceOrderConfirmData.contactWay
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  _react2.default.createElement(
                    'div',
                    { className: styles.textTil },
                    '服务价格: '
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: { color: '#ff0000' } },
                    '¥'
                  ),
                  _react2.default.createElement(
                    'span',
                    {
                      style: { color: '#ff0000' } },
                    serviceOrderConfirmData.price
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  _react2.default.createElement(
                    'div',
                    { className: styles.textTil },
                    '交付时间: '
                  ),
                  serviceOrderConfirmData.deliveryTime
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  _react2.default.createElement(
                    'div',
                    { className: styles.textTil },
                    '服务承诺: '
                  ),
                  _react2.default.createElement('img', { className: styles.chengnuoimg }),
                  _react2.default.createElement('img', { className: styles.chengnuoimg })
                )
              )
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'div',
              { style: { marginTop: 10, marginBottom: 10, fontSize: '16px', fontFamily: 'Microsoft YaHei' } },
              '服务内容'
            ),
            _react2.default.createElement(
              'p',
              { className: styles.fuwu },
              serviceOrderConfirmData.content
            ),
            _react2.default.createElement(
              'div',
              { className: styles.pageTopTitle },
              _react2.default.createElement(
                'span',
                null,
                '配送信息'
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '10px', marginLeft: '40px' } },
              _react2.default.createElement('img', {
                onClick: function onClick() {
                  return _this2.onIsExpressChange();
                },
                className: styles.checkImg,
                src: isExpress.value === '1' ? 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/radio_hover.png' : 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/radio.png',
                alt: '' }),
              _react2.default.createElement(
                'span',
                { style: { fontSize: '16px', marginLeft: '7px', fontFamily: 'Microsoft YaHei' } },
                '是否配送'
              )
            ),
            expressDiv,
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'div',
              { className: styles.pageTopTitle },
              _react2.default.createElement(
                'span',
                null,
                '发票信息'
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '10px', marginLeft: '40px' } },
              _react2.default.createElement('img', {
                onClick: function onClick() {
                  return _this2.onIsInvoiceChange();
                },
                className: styles.checkImg,
                src: isInvoice.value === '1' ? 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/radio_hover.png' : 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/radio.png',
                alt: '' }),
              _react2.default.createElement(
                'span',
                { style: { fontSize: '16px', marginLeft: '7px', fontFamily: 'Microsoft YaHei' } },
                '需要发票'
              )
            ),
            invoiceDiv
          ),
          _react2.default.createElement('div', { className: styles.link }),
          _react2.default.createElement(
            'div',
            { className: styles.tip },
            _react2.default.createElement(
              'span',
              { className: styles.span1 },
              '保'
            ),
            ' 交易服务由艺品网官方提供 交易有保障'
          ),
          _react2.default.createElement(
            'div',
            {
              style: { width: 1000, margin: '0px auto', fontSize: '14px', fontFamily: 'Microsoft YaHei', color: '#ff0000' } },
            '官方提供线上担保交易，保障您的资金安全，且不会收取您任何佣金。80%的欺诈、资金盗取均由线下交易导致，请勿线下交易。'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.boa, onClick: handleSubmit },
            _react2.default.createElement(
              'div',
              { className: styles.jin },
              '订单总额：',
              serviceOrderConfirmData.price
            ),
            _react2.default.createElement(
              'div',
              { className: styles.dui },
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/yuxuan/duia.png', alt: '' })
            ),
            payoracceptDiv
            // <div className={styles.din}>生成订单</div>

          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ServiceOrderConfirmComponent;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,

  serviceOrderConfirmData: _react.PropTypes.object }, _temp)) || _class);
exports.default = ServiceOrderConfirmComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceOrderConfirmComponent/ServiceOrderConfirmComponent.js
 ** module id = 1420
 ** module chunks = 0
 **/